import * as React from "react";
const SvgInfo16 = (props, ref) => React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref: ref, ...props },
    React.createElement("path", { fill: "currentColor", d: "M9 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-.5 2.5a.5.5 0 0 0-1 0v4a.5.5 0 0 0 1 0v-4Z" }),
    React.createElement("path", { fill: "currentColor", d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Zm7-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2Z" }));
const ForwardRef = React.forwardRef(SvgInfo16);
export default ForwardRef;
